import { TableCell } from "@rothoblaas/design-system";
import Table from "../../../../../components/ui/Table";
import useI18n from "../../../../../hooks/useTranslations";
import { BOMItem } from "../../../../../http/lock_calculator/types";
import styles from "../../LockCalculator.module.css";

type Props = { items?: BOMItem[] | null };

const categoryOrder: Record<BOMItem["category"], number> = { connector: 0, fastener: 1, lockstop: 2 };

/** Renders server-calculated rows; it contains no form or calculation logic. */
export const BomTable = ({ items }: Props) => {
  const { translation: t } = useI18n();
  const labels: Record<string, string | undefined> = {
    firstConnector: t.lockCalculatorModule?.connection?.connectorOne,
    secondConnector: t.lockCalculatorModule?.connection?.connectorTwo,
    headerLock: t.lockCalculatorModule?.bom?.headerLock,
    headerFastener: t.lockCalculatorModule?.fasteners?.headerFastener,
    joistFastener: t.lockCalculatorModule?.fasteners?.joistFastener,
    upliftFastener: t.lockCalculatorModule?.fasteners?.upliftFastener,
    lockstop: t.lockCalculatorModule?.fasteners?.lockstop,
  };
  const rows = items ? [...items].sort((a, b) => categoryOrder[a.category] - categoryOrder[b.category]) : [];

  if (rows.length === 0) {
    return <p className={styles.emptyConfigurationsMessage}>{t.lockCalculatorModule?.bom?.noComponents}</p>;
  }

  return (
    <div className={styles.tabTableWrapper}>
      <Table<BOMItem>
        items={rows}
        head={
          <tr>
            <TableCell>{t.lockCalculatorModule?.bom?.component}</TableCell>
            <TableCell>{t.common.code}</TableCell>
            <TableCell>{t.lockCalculatorModule?.bom?.quantity}</TableCell>
          </tr>
        }
        renderRow={(item) => (
          <>
            <TableCell>{labels[item.label] ?? item.label}</TableCell>
            <TableCell>{item.item.code}</TableCell>
            <TableCell>{item.quantity}</TableCell>
          </>
        )}
      />
    </div>
  );
};
